import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default ({
  title,
  ...extra
}) => /*#__PURE__*/_jsxs("svg", {
  height: "50",
  width: "50",
  viewBox: "0 0 50 50",
  ...extra,
  children: [title, /*#__PURE__*/_jsx("path", {
    d: "M37.5 46.6h-25L0 24.964 12.5 3.327h25L50 24.964 37.5 46.6zm-22.942-3.514h20.934l10.442-18.122L35.442 6.842H14.558L4.066 24.964l10.492 18.122z"
  })]
});